import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Tooltip } from "react-tooltip";
import { getTemplateDetail, updateTemplateDetail } from "../../../../utils/clickToCallApi";
import '../../../../assets/css/loader.css'; 

//Import Widgets
import DynamicTemplate from "../../../../components/Apps/ClickToCall/Template/DynamicTemplate";

//Import Tabs
import ContentTab from "../../../../components/Apps/ClickToCall/ContentTab";
import PositionTab from "../../../../components/Apps/ClickToCall/PositionTab";
import SettingTab from "../../../../components/Apps/ClickToCall/SettingTab";
import StyleTab from "../../../../components/Apps/ClickToCall/StyleTab";

export default function CreateClickToCall() {
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [activeSection, setActiveSection] = useState("Content");
    const [activeTemplateSection, setActiveTemplateSection] = useState("");
    const [selectedLayout, setSelectedLayout] = useState("");
    const [selectedTemplateImage, setSelectedTemplateImage] = useState("");
    const { uuid } = useParams();
    const [isTemplateId, setIsTemplateId] = useState(null);
    const [clickToCallTabData, setClickToCallTabData] = useState({
        is_website_frontend: "", 
        content_phone_number: "",  
        content_is_show_button_icon: 1,  
        content_button_text: "Call Us",  
        content_call_window_picture: "",  
        content_call_window_name: "Call Us Now",  
        content_call_window_caption: "",  
        content_call_window_message: "",  
        content_call_window_format_phone_number: 1,  
        postion_postion_type: "right-side",  
        setting_pages_type: "All_Pages",  
        setting_devices_type: ["Desktop", "Tablets", "Phones"],    
        setting_visitors_type: "All_Visitors",  
        setting_schedule_days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],  
        setting_schedule_is_set_the_time_schedule: 1,  
        setting_schedule_start_time: "12:00 AM",  
        setting_schedule_end_time: "1:00 AM",  
        setting_schedule_time_zone: "", 
        setting_open_call_window_triggers_is_on_page_load: 1,  
        setting_open_call_window_triggers_time_on_page: "",  
        setting_open_call_window_triggers_time_on_site: "",  
        setting_open_call_window_triggers_scroll_position: "",  
        setting_open_call_window_triggers_is_exit_intent: 1,     
        style_button_color: "#212223",     
        style_button_icon_text_color: "#fff",     
        style_window_background_color: "#212223",     
        style_window_message_color: "#fff",     
        style_window_phone_number_color: "#71ef29",     
        style_font_type: "",     
        style_button_size: "50",  
        style_name_font_size: "14px",     
        style_caption_font_size: "14px",     
        style_message_font_size: "14px",     
        style_phone_number_font_size: "14px",        
        style_button_animation: "",     
        style_animation_interval: "",     
        style_custom_css: "",     
        style_custom_js: "",       
    });
    const [renameWidgetNameModel, setRenameWidgetNameModel] = useState(false);
    const [widgetName, setWidgetName] = useState("Untitled Click To Call");
    const [newWidgetName, setNewWidgetName] = useState("");

    // Open Widget Name Popup
    const openRenameWidgetNamePopup = () => {
        setNewWidgetName(widgetName);
        setRenameWidgetNameModel(true);
        document.body.classList.add("popup-open");
    };

    // Close Widget Name Popup
    const closeRenameWidgetNamePopup = () => {
        setRenameWidgetNameModel(false);
        document.body.classList.remove("popup-open");
    };

    // Save Widget Name Popup
    const saveWidgetName = () => {
        if (newWidgetName.trim() !== "") {
            setWidgetName(newWidgetName); 
        }
        closeRenameWidgetNamePopup();
    };

    // Function to update values dynamically
    const updateClickToCallTabData = (key, value) => {
        setClickToCallTabData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const menuItems = [
        { key: "Content", icon: "content.png", label: "Content" },
        { key: "Position", icon: "position.png", label: "Position" },
        { key: "Setting", icon: "setting.png", label: "Settings" },
        { key: "Style", icon: "style.png", label: "Style" },
    ];
   
   // Fetching Template Data
    useEffect(() => {
        const fetchData = async () => {
            try {
                const templateResult = await getTemplateDetail(uuid);

                // Check if result exists
                if (templateResult.data) {
                    setIsTemplateId(templateResult.data.uuid);
                    setWidgetName(templateResult.data.name);
                    setActiveTemplateSection(templateResult.data.template_name);
                    setSelectedLayout(templateResult.data.layout_type);
                    setSelectedTemplateImage(templateResult.data.template_image);

                    // Convert settings array to object
                    const settingsObject = templateResult.data.settings.reduce((acc, setting) => {
                        acc[setting.setting_key] = setting.setting_value;
                        return acc;
                    }, {});

                    setClickToCallTabData(settingsObject); 
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, [uuid, setClickToCallTabData]); 


    //Update Form data
    const updateForm = async (e) => {
        e.preventDefault();

        setIsSubmitting(true);
        try {
            const extractedImageName = selectedTemplateImage.split('/').pop();
            const formData = new FormData();

            // Append text fields
            formData.append("template_id", isTemplateId);
            formData.append("name", widgetName);
            formData.append("template_name", activeTemplateSection);
            formData.append("template_image", extractedImageName);
            formData.append("layout_name", selectedLayout);
            formData.append("layout_type", selectedLayout);
    
            // Append settings as JSON string
            formData.append(
                "settings",
                JSON.stringify(
                    Object.entries(clickToCallTabData).map(([key, value]) => ({
                        setting_key: key,
                        setting_value: value,
                    }))
                )
            );

            // Check if content_call_window_picture is a File and append it
            if (clickToCallTabData.content_call_window_picture) {
                // If it's a File object (newly uploaded), append it directly
                if (clickToCallTabData.content_call_window_picture instanceof File) {
                    formData.append("content_call_window_picture", clickToCallTabData.content_call_window_picture);
                } 
                // If it's a string (from predefined template), just send the image file name
                else if (typeof clickToCallTabData.content_call_window_picture === 'string') {
                    const imageName = clickToCallTabData.content_call_window_picture.split('/').pop();
                    formData.append("content_call_window_picture", imageName);
                }
            }
            
            //Api Call
            let api_response = await updateTemplateDetail(formData);

            //Check Responce
            if (api_response.status === true) {
                toast.success(api_response.message);
                // Redirect after 2 seconds
                setTimeout(() => {
                    navigate('/customer/apps/click-to-call');
                }, 2000); 
            } else {
                toast.error(api_response.message);
            }
        } catch (error) {
            toast.error('Oops Something Wrong. Please Try Again!' + error.message);
        } finally {
            setIsSubmitting(false);
        }
    };

  return (
    <>
      <div className="create-goole-reviews-all">
            <div className="overlay-side-baar">
                <div className="side-baar-inner-one">
                    <ul>
                        {menuItems.map((item) => (
                            <li key={item.key}>
                                <button
                                    className={activeSection === item.key ? "active" : ""}
                                    onClick={() => setActiveSection(item.key)}
                                >
                                    <img
                                        src={`${process.env.PUBLIC_URL}/click-to-call/icons//${item.icon}`}
                                        alt={`${item.key} icon`}
                                    />
                                    <span>{item.label}</span>
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="side-baar-inner-tow">
                    {/* Conditional Rendering for Sections */}
                    {activeSection === "Content" && (
                        <ContentTab updateClickToCallTabData={updateClickToCallTabData} clickToCallTabData={clickToCallTabData}/>
                    )}
                    {activeSection === "Position" && (
                        <PositionTab updateClickToCallTabData={updateClickToCallTabData} clickToCallTabData={clickToCallTabData}/>
                    )}
                    {activeSection === "Setting" && (
                        <SettingTab updateClickToCallTabData={updateClickToCallTabData} clickToCallTabData={clickToCallTabData}/>
                    )}
                    {activeSection === "Style" && (
                        <StyleTab updateClickToCallTabData={updateClickToCallTabData} clickToCallTabData={clickToCallTabData}/>
                    )}
                </div>
            </div>
            <div className="create-goole-reviews-right">
                <div className="content-wrapper">
                    <div className="source-header-row">
                        <h2><Link to="/customer/apps/click-to-call"><i className="fa fa-angle-left" aria-hidden="true"></i> Back</Link></h2>
                        <div className="untitled-widget-name app-icon-clickto-call">
                            <button onClick={openRenameWidgetNamePopup} data-tooltip-id="rename-tooltip"><img src={`${process.env.PUBLIC_URL}/images/app-icon/app-icon-3.svg`} alt="app-icon-3"/>{ widgetName }</button>
                            <Tooltip id="rename-tooltip" place="top" content="Rename Widget" />
                        </div>
                        <div className='submit-google-review'>
                          <button type="button" onClick={updateForm} className={`form-button ${isSubmitting ? 'disabled' : ''}`} disabled={isSubmitting}>Publish</button>
                          <Link to="/customer/apps/click-to-call/pricing/single" className="view-plan">View Plans</Link>
                          <Link to="/customer/apps/click-to-call" className="close-button">Close</Link></div>
                    </div>
                    <div className="source-title-row">Click To Call <i className="fa fa-angle-right" aria-hidden="true"></i> <strong>Connect</strong></div>

                    {/*Check template type*/}
                    {activeTemplateSection === "Call_Us_Temp" && (
                      <DynamicTemplate selectedTemplate={activeTemplateSection} clickToCallTabData={clickToCallTabData}/>
                    )}
                    {activeTemplateSection === "Sale_Temp" && (
                      <DynamicTemplate selectedTemplate={activeTemplateSection} clickToCallTabData={clickToCallTabData}/>
                    )}
                    {activeTemplateSection === "Consultation_Temp" && (
                      <DynamicTemplate selectedTemplate={activeTemplateSection} clickToCallTabData={clickToCallTabData}/>
                    )}
                    {activeTemplateSection === "Support_Temp" && (
                      <DynamicTemplate selectedTemplate={activeTemplateSection} clickToCallTabData={clickToCallTabData}/>
                    )}
                    {activeTemplateSection === "Booking_Temp" && (
                      <DynamicTemplate selectedTemplate={activeTemplateSection} clickToCallTabData={clickToCallTabData}/>
                    )}
                    {activeTemplateSection === "Floating_Call_Button_Temp" && (
                      <DynamicTemplate selectedTemplate={activeTemplateSection} clickToCallTabData={clickToCallTabData}/>
                    )}
                </div>
            </div>
        </div>

        {/* Rename Popup */}
        {renameWidgetNameModel && (
            <div className="fixed top-50 left-50 w-full h-full bg-opacity-50 flex justify-center items-center popup-main rounded overflow-hidden widget-rename-model">
                <div className="bg-white p-3 rounded-lg shadow-lg">
                    <h3 className="text-lg font-semibold">Rename Widget</h3>
                    <label>Widget Name</label>
                    <input
                        type="text"
                        className="border p-2 w-full mt-2"
                        value={newWidgetName}
                        onChange={(e) => setNewWidgetName(e.target.value)}
                    />
                    <div className="mt-3 flex justify-end">
                        <button className="px-3 py-1 bg-gray-200 rounded mr-2" onClick={closeRenameWidgetNamePopup}>
                            Cancel
                        </button>
                        <button type="button" className="px-3 py-1 bg-blue-500 text-white rounded" onClick={saveWidgetName}>
                            Save
                        </button>
                    </div>
                </div>
            </div>
        )}
    </>
  );
} 